
import React, { useEffect } from 'react';
import { recursiveGroupData } from '../utils/sales';
import PivotTable from './pivotTable/PivotTable';


interface Props {
  tableData: ISalesAnnualComparisonByWeek[];
}

const SalesAnnualComparisonByWeek: React.FC<Props> = ({ tableData = [] }) => {
  const [groupedData, setGroupedData] = React.useState({});

  useEffect(() => {
    setGroupedData(recursiveGroupData(tableData, ['year', 'quarter', 'month', 'week']));
  }, [tableData]);

  return (
    <div className="grid-item">
      <h4 className="px-5 py-2 text-light-gray text-center bg-light-blue">
        Weekly Sales Annual Comparison
      </h4>
      <PivotTable groupedData={groupedData} />
    </div>
  );
};

export default SalesAnnualComparisonByWeek;
